module.exports = __webpack_public_path__ + "img/BubbleTea.31828241.jpeg";